import {createSvgIcon} from '../create-svg-icon';

export const SignalCellularOffIcon = createSvgIcon(
  <path d="m21 1-8.31 8.31 8.31 8.3zM4.91 4.36 3.5 5.77l6.36 6.37L1 21h17.73l2 2 1.41-1.41z" />
, 'SignalCellularOffOutlined');
